<template>
  <div class="gradient-card" @click="$emit('click')">
    <div :class="innerClass">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GradientCard',
  props: {
    innerClass: {
      value: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import './gradient-card';
</style>
